/**
 * Photo constraints for use with photocrop
 *
 * aspect ratio, min height, min width
 *
 * @author pponzeka@yext.com
 */
goog.module('yext.image.Constraints');
goog.module.declareLegacyNamespace();

/**
 * @constructor
 *
 * @param {!Object} options Override default options if needed
 */
const Constraints = function(options) {
  this.constraints = $.extend(true, {}, Constraints.defaults, options.constraints);
  if (options.container) {
    this.getConstraintsFromContainer(options.container);
  }
};

/**
 * The constraints are necessary for photos and editing images to certain constraints.
 * The following constraints are the defaults for our photo chooser
 */
Constraints.defaults = {
  'width': 1,
  'height': 1,
  'aspectRatioId': 1, // matches alpha.photo_aspect_ratios for unconstrained
  'maxFileSize': 5, // max file size in MB
  'minFileSize': 0, // min file size in bytes
  'cropOnlyOnInteraction': true, // dont convert the image to data-url by default
  'maxHeight': 0,
  'maxWidth': 0,
  'maxPixels': 0,
};

Constraints.prototype.getConstraintsFromContainer = function(container) {
  var minHeight = parseInt(container.data('min-height'));
  var minWidth = parseInt(container.data('min-width'));
  var aspectRatio = container.data('cropper');
  var aspectRatioId = parseInt(container.data('aspect-ratio'));
  var maxFileSize = parseInt(container.data('max-file-size'));
  var minFileSize = parseInt(container.data('min-file-size'));
  var cropOnlyOnInteraction = !!container.data('crop-only-on-interaction');
  var maxHeight = parseInt(container.data('max-height'));
  var maxWidth = parseInt(container.data('max-width'));
  var maxPixels = parseInt(container.data('max-pixels'));

  if (minHeight) {
    this.constraints.height = minHeight;
  }

  if (minWidth) {
    this.constraints.width = minWidth;
  }

  if (maxHeight) {
    this.constraints.maxHeight = maxHeight;
  }

  if (maxWidth) {
    this.constraints.maxWidth = maxWidth;
  }

  if (aspectRatio) {
    this.constraints.aspectRatio = aspectRatio;
  }

  if (aspectRatioId) {
    this.constraints.aspectRatioId = aspectRatioId;
  }

  if (maxFileSize) {
    this.constraints.maxFileSize = maxFileSize;
  }

  if (minFileSize) {
    this.constraints.minFileSize = minFileSize;
  }

  if (cropOnlyOnInteraction) {
    this.constraints.cropOnlyOnInteraction = cropOnlyOnInteraction;
  }

  if (maxPixels) {
    this.constraints.maxPixels = maxPixels;
  }
};

Constraints.prototype.get = function() {
  return this.constraints;
};

exports = Constraints;
